import { perkpointApi, type ApiPage } from "./client";

/** Program outlets (api/src/services/outlets.js). Names are what fraud rules and enrolment store. */

export type ApiOutlet = {
  id: string;
  program_id: string;
  name: string;
  address: string;
  city: string;
  state: string;
  country: string;
  postal_code: string;
  phone: string;
  email: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
};

export type OutletInput = {
  name: string;
  address: string;
  city: string;
  state: string;
  country: string;
  postal_code: string;
  phone: string;
  email: string;
};

export type OutletListQuery = {
  search?: string;
  page?: number;
  page_size?: number;
};

export const outletKeys = {
  all: ["perkpoint", "outlets"] as const,
  list: (programId: string, query: OutletListQuery = {}) =>
    ["perkpoint", "outlets", programId, query] as const,
};

const base = (programId: string) => `/admin/programs/${programId}/outlets`;

export const OutletsApi = {
  async list(programId: string, query: OutletListQuery = {}) {
    const { data } = await perkpointApi.get<ApiPage<ApiOutlet>>(base(programId), { params: query });
    return data;
  },
  async create(programId: string, input: OutletInput) {
    const { data } = await perkpointApi.post<ApiOutlet>(base(programId), input);
    return data;
  },
  async update(programId: string, outletId: string, input: OutletInput) {
    const { data } = await perkpointApi.patch<ApiOutlet>(`${base(programId)}/${outletId}`, input);
    return data;
  },
  async remove(programId: string, outletId: string) {
    const { data } = await perkpointApi.delete<{ id: string; name: string; is_active: boolean }>(
      `${base(programId)}/${outletId}`,
    );
    return data;
  },
};
